import { message } from 'antd';
// eslint-disable-next-line
import router from 'umi/router';
import { getLogSearchWithPage } from '../../../../../services/contacts/log';

// 设置加载属性
const setSpinProps = ({ put, spinning = false, tip = '', ...otherData }) => {
  return put({
    type: 'save',
    payload: {
      spinProps: {
        spinning,
        tip,
      },
      ...otherData,
    },
  });
};

const initState = () => {
  return {
    data: [],
    totalElements:0,
    page:1,
    pageSize:10,
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
  };
};

export default {
  namespace: 'operationLog',

  state: initState(),

  effects: {
    *search({ params }, { call, put }) {
      try {
        yield setSpinProps({ spinning: true, tip: '查询中', put });

        const { content, totalElements, page, pageSize } = yield call(getLogSearchWithPage, params);

        yield setSpinProps({ put, data:content, totalElements, page, pageSize });
      } catch (error) {
        message.error(error.msg || '网络错误，请重试');
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
